<template  >
	<div class="require-login-modal" >
		<FullBackdrop >
			<div class="container" >
				<h3 class="modal-title">{{$t('modal_chat.login.title')}}</h3>
				<p class="content-text">
					{{$t('require_login.text')}}
				</p>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
					<router-link
							class="action"
							:to="{ name: 'login' }"
						>
						<button>{{$t('modal_chat.login.button')}}</button>
					</router-link>
				</div>
			</div>
		</FullBackdrop>
	</div>
</template>
<script>
import FullBackdrop from "./FullBackdrop";
export default {
  components: { FullBackdrop },
  methods: {
    cancelHandler() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/variables";
@import "../styles/classes";

.require-login-modal {
  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
      width: 500px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .content-text {
      font-weight: bold;
      text-transform: uppercase;
    }

    & .footer {
      display: flex;
      justify-content: center;

      & button {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
        margin-left: 1rem;

        > button {
          @extend %secondary-btn;
          margin-left: 0;
        }
      }
    }
  }

  & button.cancel {
    @extend %fresh-btn;

    border-radius: 0.5rem;
  }

  & .error-message {
    color: red;
  }
}
</style>
